module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.activeWindow),
      callback: function($$v) {
        _vm.activeWindow = $$v
      },
      expression: "activeWindow"
    }
  }, [_c('v-window-item', {
    key: 0
  }, [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "flat": ""
    }
  }, [(_vm.withHeader) ? _c('v-card-title', {
    staticClass: "overline"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        return _vm.$emit("back")
      }
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    class: {
      "pa-2": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [(!_vm.editMode) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('space-picker', {
    attrs: {
      "with-select": false,
      "label": "Where would you like to save this client?"
    },
    model: {
      value: (_vm.client.spaces),
      callback: function($$v) {
        _vm.$set(_vm.client, "spaces", $$v)
      },
      expression: "client.spaces"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editMode || (_vm.client.spaces && _vm.client.spaces.length > 0)) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('server-errors', {
    attrs: {
      "request": _vm.createRequest
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Full name",
      "rules": [_vm.rules.required],
      "hint": "The client's name and surname. e.g.: Jon Snow"
    },
    model: {
      value: (_vm.client.full_name),
      callback: function($$v) {
        _vm.$set(_vm.client, "full_name", $$v)
      },
      expression: "client.full_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('phone-number-input', {
    attrs: {
      "short-list": ["ZA"],
      "selected-country-code": "ZA",
      "touch": _vm.contactSelectedPhone
    },
    on: {
      "number": _vm.setClientPhone,
      "valid": _vm.setValidPhoneNumber
    },
    model: {
      value: (_vm.contactSelectedPhone),
      callback: function($$v) {
        _vm.contactSelectedPhone = $$v
      },
      expression: "contactSelectedPhone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "",
      "lg6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "type": "email",
      "rules": [_vm.rules.email],
      "hint": "e-mail address. e.g.: jon@gmail.com"
    },
    model: {
      value: (_vm.client.email),
      callback: function($$v) {
        _vm.$set(_vm.client, "email", $$v)
      },
      expression: "client.email"
    }
  })], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": "",
      "full-width": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pl-0 overline py-0",
    on: {
      "click": function($event) {
        _vm.showExtra = !_vm.showExtra
      }
    }
  }, [(_vm.showExtra === false) ? _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.showExtra === true) ? _c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("remove")])], 1) : _vm._e(), _vm._v("\n                Extra fields\n              ")], 1), _vm._v(" "), (_vm.showExtra) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Client ID",
      "hint": "If you store some form of ID for recognizing your clients, you can use this to keep track"
    },
    model: {
      value: (_vm.client.custom_id),
      callback: function($$v) {
        _vm.$set(_vm.client, "custom_id", $$v)
      },
      expression: "client.custom_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nickname",
      "hint": "If the client has a nickname or a name that they prefer to be called by"
    },
    model: {
      value: (_vm.client.nickname),
      callback: function($$v) {
        _vm.$set(_vm.client, "nickname", $$v)
      },
      expression: "client.nickname"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.editMode) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mb-1 pb-0",
    attrs: {
      "hide-details": "",
      "label": "Update information on related appointments"
    },
    model: {
      value: (_vm.updateAppointments),
      callback: function($$v) {
        _vm.updateAppointments = $$v
      },
      expression: "updateAppointments"
    }
  }), _vm._v(" "), _c('small', {
    attrs: {
      "color": "primary mt-1"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n                When you create an appointment contact information is copied to the appointment (name, phone, email).\n                Select this option to have AppointmentGuru update this information on this user's appointments with your changes\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.contactClient && _vm.showContactClient) ? _c('v-card', {
    attrs: {
      "full-width": ""
    }
  }, [_c('v-card-text', [_c('v-layout', [_c('v-subheader', [_c('v-icon', [_vm._v("person")]), _vm._v("\n                      Contact details: " + _vm._s(_vm.contactClient.name.formatted))], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showContactClient = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', [_vm._v("Phone numbers")]), _vm._v(" "), (_vm.contactClient.phoneNumbers && _vm.contactClient.phoneNumbers.length > 0) ? _c('v-radio-group', {
    attrs: {
      "mandatory": false
    }
  }, _vm._l((_vm.contactClient.phoneNumbers), function(number) {
    return _c('v-radio', {
      key: number,
      attrs: {
        "label": number,
        "value": number
      },
      on: {
        "change": function($event) {
          return _vm.setSelectedNumber(number)
        }
      }
    })
  }), 1) : _c('div', [_vm._v("No phone numbers found")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-subheader', [_vm._v("Email")]), _vm._v(" "), (_vm.contactClient.emails && _vm.contactClient.emails.length > 0) ? _c('v-radio-group', {
    attrs: {
      "mandatory": false
    },
    model: {
      value: (_vm.contactSelectedEmail),
      callback: function($$v) {
        _vm.contactSelectedEmail = $$v
      },
      expression: "contactSelectedEmail"
    }
  }, _vm._l((_vm.contactClient.emails), function(email) {
    return _c('v-radio', {
      key: email.id,
      attrs: {
        "label": email,
        "value": email
      },
      on: {
        "change": function($event) {
          _vm.client.email = email
        }
      }
    })
  }), 1) : _c('div', [_vm._v("No emails found")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.editMode) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("\n                  Clear")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.hasContacts) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.pickContact
    }
  }, [_c('v-icon', [_vm._v("person_add")]), _vm._v(" Contacts")], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2"
  }, [(_vm.matchingClients && _vm.matchingClients.length > 0 && !_vm.editMode) ? _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "color": "warning",
            "outline": "",
            "block": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("warning")]), _vm._v("\n                " + _vm._s(_vm.matchingClients.length) + "\n                Similar clients found\n                "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }], null, false, 3454799101),
    model: {
      value: (_vm.showMatchingClients),
      callback: function($$v) {
        _vm.showMatchingClients = $$v
      },
      expression: "showMatchingClients"
    }
  }, [_vm._v(" "), _c('span', [_c('v-list', {
    staticClass: "pa-0 elevation-10",
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline grey lighten-4"
  }, [_vm._v("\n                    Some matches found\n                    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMatchingClients = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.matchingClients.slice(0, 10)), function(client) {
    return [_c('client-list-item', {
      key: client.id,
      attrs: {
        "with-action": false,
        "relationship-id": client.id,
        "client": client.client
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.$emit("clientselected", client.client)
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (client.id))
    })]
  }), _vm._v(" "), (_vm.matchingClients.length > 10) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n                      .. and " + _vm._s(_vm.matchingClients.length - 10) + " more\n                    ")])], 1) : _vm._e()], 2)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "width": "100%"
    }
  }, [(_vm.editMode) ? _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("Updated client: Please confirm")]) : _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-1"
  }, [_vm._v("New client: Please confirm")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [(_vm.client.full_name) ? _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('client-list-item', {
    attrs: {
      "relationship-id": 0,
      "client": _vm.clientFormatted
    }
  }, [_c('template', {
    slot: "action"
  }, [(_vm.clientIsValid && _vm.hasSomeContactDetails) ? _c('v-icon', {
    attrs: {
      "slot": "action",
      "color": "success",
      "dark": ""
    },
    slot: "action"
  }, [_vm._v("check_circle")]) : _vm._e(), _vm._v(" "), (_vm.clientIsValid && !_vm.hasSomeContactDetails) ? _c('v-icon', {
    attrs: {
      "slot": "action",
      "color": "amber",
      "dark": ""
    },
    slot: "action"
  }, [_vm._v("warning")]) : _vm._e()], 1), _vm._v(" "), (!_vm.hasSomeContactDetails) ? _c('template', {
    slot: "subtitle"
  }, [_c('v-list-tile-sub-title', [_c('span', {
    staticClass: "yellow pa-2"
  }, [_c('strong', [_vm._v("Warning")]), _vm._v(" This client has no contact details specified")])]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "pl-1"
  }, [_vm._v("\n                        You can still save this client. It's just recommended to capture some form of contact information\n                      ")])], 1) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-right pb-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "is-block": "",
      "is-disabled": !_vm.clientIsValid,
      "req-id": _vm.reqId,
      "text": _vm.btnTxt,
      "classes": ["ma-0"]
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1), _vm._v(" "), (_vm.singleErrorMessage) ? _c('p', {
    staticClass: "warning lighten-2 pa-3 subheading"
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.singleErrorMessage))], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.withBack) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("back")
      }
    }
  }, [_vm._v(_vm._s(_vm.backText))]) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', {
    key: 1
  }, [_c('v-list', _vm._l((_vm.actions), function(action) {
    return _c('v-list-tile', {
      key: action.icon,
      on: {
        "click": function($event) {
          return action.onclick(_vm.savedContact)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(action.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(action.title)
      }
    }), _vm._v(" "), (action.subtitle) ? _c('v-list-tile-sub-title', {
      domProps: {
        "textContent": _vm._s(action.subtitle)
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9051f65e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/Create.vue
// module id = 1495
// module chunks = 9